import React from "react";
import ct from "class-types.macro";
import {
  NewItemsBranchCategory,
  NewItemsLeafCategory,
} from "./NewItemsPageResult";

interface Props {
  branchCategories: NewItemsBranchCategory[];
}

export default function NewItemsBranchAndLeafCategories({
  branchCategories,
}: Props) {
  return (
    <div
      className={ct(
        "grid",
        "mx-auto",
        "mt-16",
        "grid-cols-2",
        "xs:grid-cols-3",
        "lt:grid-cols-4"
      )}
    >
      {branchCategories.map(
        ({ name, image, leafCategories }: NewItemsBranchCategory) => (
          <div
            className={ct(
              "box-border",
              "flex",
              "flex-col",
              "mb-2",
              "px-1",
              "text-center"
            )}
            key={name}
          >
            <img src={image} className={ct("mx-auto", "w-2/4")} alt={name} />
            <h3
              className={ct(
                "font-bold",
                "text-base",
                "leading-none",
                "mb-0",
                "mb-4",
                "mt-6"
              )}
            >
              {name}
            </h3>
            {leafCategories.map(
              ({ filterUrl, label }: NewItemsLeafCategory) => (
                <a
                  href={filterUrl}
                  className={ct(
                    "block",
                    "text-sm",
                    "leading-none",
                    "mb-2",
                    "hover:underline"
                  )}
                >
                  {label}
                </a>
              )
            )}
          </div>
        )
      )}
    </div>
  );
}
